import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineNotification } from 'eds/Notifications';
import { ENotificationVariant } from 'eds/Notifications/types';
import TrackerSubstitution from 'utils/Tracker.substitution';

interface IProps {
  count: number;
  onRefresh: () => void;
}

const OOSSubstitutesError: React.FC<IProps> = ({ count, onRefresh }) => {
  const { t } = useTranslation();
  useEffect(() => {
    TrackerSubstitution.fetchSubstituteFailureTracking();
  }, []);

  return (
    <InlineNotification
      variant={ENotificationVariant.WARNING}
      title={t('oosReplacement.errorTitle', {
        count,
      })}
      description={t('oosReplacement.errorSubtitle')}
      showBorder
      actionLabel={t('oosReplacement.refresh')}
      onClick={onRefresh}
      isShowAction
    />
  );
};

export default OOSSubstitutesError;
